import * as React from 'react'
const CheckboxMark = (props) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={16}
		height={13}
		fill='none'
		{...props}
	>
		<path
			stroke='#002649'
			strokeLinecap='round'
			strokeLinejoin='round'
			strokeWidth={3}
			d='m2 7 4 4 8-9'
		/>
	</svg>
)
export default CheckboxMark
